import { useState } from "react";

export const inputCls =
  "w-full rounded-sm border border-input bg-background px-4 py-3 text-sm outline-none transition-colors duration-200 focus:border-primary focus:ring-1 focus:ring-primary";

export const labelCls = "mb-2 block text-xs font-semibold uppercase tracking-[0.15em] text-foreground/60";

export const FormActions = ({ saving, onCancel }) => (
  <div className="flex flex-wrap gap-3 pt-2">
    <button
      type="submit"
      disabled={saving}
      data-testid="admin-form-save-button"
      className="rounded-sm bg-primary px-8 py-3 text-sm font-semibold text-primary-foreground transition-[background-color,opacity] duration-200 hover:bg-[hsl(22,83%,40%)] disabled:cursor-not-allowed disabled:opacity-60"
    >
      {saving ? "Enregistrement…" : "Enregistrer"}
    </button>
    <button
      type="button"
      onClick={onCancel}
      data-testid="admin-form-cancel-button"
      className="rounded-sm border border-foreground/20 px-8 py-3 text-sm font-semibold transition-colors hover:border-primary hover:text-primary"
    >
      Annuler
    </button>
  </div>
);
